import { Card, Flex, Divider, Text, Title, type BoxProps } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreInquiry } from '@flecto/types'

import { TextCurrencyStore } from '../TextCurrencyStore/TextCurrencyStore'
import { RowItem } from './RowItem'

export type CardOrderSummaryProps = BoxProps & {
  order?: CoreInquiry
}

export function CardOrderSummary({ order, ...props }: CardOrderSummaryProps) {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-confirmation',
  })

  if (!order) {
    return
  }

  return (
    <Card style={{ height: 'max-content' }} {...props}>
      <Title order={5} mb='md'>
        {t('card_order_summary.title')}
      </Title>
      <Flex direction='column' gap='lg'>
        {order.inquiry_items?.map((i, key) => <RowItem key={key} item={i} />)}
      </Flex>
      <Card.Section>
        <Divider color='gray.2' my='lg' />
      </Card.Section>
      <Flex align='center' justify='space-between' mb='sm'>
        <Text fw={500}>{t('card_order_summary.label_total')}</Text>
        <TextCurrencyStore
          cents={order.meta?.estimated_booking_cost_with_vat_cents ?? 0}
        />
      </Flex>
    </Card>
  )
}
